import SortContext from "context/SortContext";
import CatalogueScreen from "features/catalogue/components/CatalogueScreen";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function Catalogue() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.innerChnages) return;
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get("crmState");
    if (!encoded) return;
    try {
      const crmState = JSON.parse(atob(encoded));
      navigate("/Catalog", { replace: true, state: { ...crmState, innerChnages: true, newName: "Create Order" } });
    } catch (_) {}
  }, []);

  return (
    <>
      <CatalogueScreen />
    </>
  );
}

export default Catalogue;
